import React from "react";
import PropTypes from "prop-types";

export const Facebook = ({ color = "#3B5998" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
      <path
        d="M18.7828 10.3687C18.7828 5.66366 14.9937 1.85156 10.3172 1.85156C5.6406 1.85156 1.85156 5.66366 1.85156 10.3687C1.85156 14.6197 4.94731 18.1433 8.99442 18.7828V12.8308H6.84388V10.3687H8.99442V8.49217C8.99442 6.35774 10.2574 5.17873 12.1919 5.17873C13.1183 5.17873 14.0871 5.34496 14.0871 5.34496V7.43989H13.0193C11.968 7.43989 11.6399 8.09654 11.6399 8.77001V10.3687H13.9878L13.6123 12.8308H11.6399V18.7828C15.687 18.1433 18.7828 14.6197 18.7828 10.3687Z"
        fill="white"
      />
    </svg>
  );
};
Facebook.propTypes = {
  color: PropTypes.string,
};
